import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { AgendaShift, AgendaUserType, GetAgendaShiftQuery, GetAgendaShiftQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, PunchsByShiftQuery, PunchsByShiftQueryVariables, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaShift, getAgendaUser, punchsByShift, shiftsByComId, shiftsByUser, updateAgendaShift, usersByComId } from './queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Button, Col, Modal, Row, Spinner, Stack } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { FaRankingStar } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from 'js-cookie';
import CustomModal from '../../components/Modals/CustomModal';
import UserImage from '../../components/UserImage';
import { MdSwapHorizontalCircle } from "react-icons/md";
import Sidebar from '../services/Sidebar/Sidebar';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import useDateService from '../services/DateService';
import { useNotification } from '../../contexts/NotificationProvider';
import useNotificationStorageService from '../services/NotificationStorageService';
import TopicNotificationService from '../services/TopicService';
import useHelperService from '../services/HelperService';
import useShiftService from '../services/ShiftService';
import StarRating from '../services/ShiftService/StarRating';
import { IoRibbon, IoMedal } from "react-icons/io5";
import { FaMedal } from "react-icons/fa6";
import { BsFillTrophyFill } from "react-icons/bs";
import { GiTrophy } from "react-icons/gi";



const containerStyle = {
  // width: '100%',
  // height: '100vh'
  marginTop: '3%',
  overflow: 'hidden', 
  width: '90%', 
  height: '95%', 
  // borderRadius: 600, 
  alignSelf: 'center',
  backgroundColor: 'white',
  // elevation: 10, // Ombre sur Android
  // boxShadow: '0 10px 20px rgba(0, 0, 0, 0.25)',
};

const defaultCenter = {
  lat: 37.78825,
  lng: -122.4324
};

const ShiftView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // NAVIGATION
  const navigate = useNavigate();
  const location = useLocation();
  // DATE SERVICES
  const {getTIMEZONE, getDateMinusDays, getDatePlusDays} = useDateService();
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // NOTIFICATION
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const shiftCount = notificationContext?.shiftCount;
  const setShiftCount = notificationContext?.setShiftCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const setConfirmShiftCount = notificationContext?.setConfirmShiftCount;
  const {updateNotificationModelCount} = useNotificationStorageService();
  // LINK
  const setShiftLink = notificationContext?.setShiftLink;
  const setConfirmShiftLink = notificationContext?.setConfirmShiftLink;
  const {sendTopicNotification} = TopicNotificationService();
  // BUTTONS
  const [loadingButton, setLoadingButton] = useState(false);
  // HONOR
    const [honorData, setHonorData] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  const [showRankModal, setShowRankModal] = useState(false);
  const [showHonorModal, setShowHonorModal] = useState(false);

  // RANK
  const [shiftData, setShiftData] = useState({
      quality: '0',
      performance: '0',
      punctuality: '0',
      rate: '0',
  });
  // PUNCH
  const [nextToken, setNextToken] = useState('');
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const isRefreshingRef = useRef(false);
  // GMAP
  const mapRef = useRef<google.maps.Map | null>(null);
  const [center, setCenter] = useState(defaultCenter);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyAd6WaR-ymbuwFFX51p5SXUK8UBOCK5M90' // Remplace par ta clé API
  });
  //DB QUERIES
  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});
    
  const {data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaShiftQuery, GetAgendaShiftQueryVariables>
      (getAgendaShift, {variables: {
        shiftId: id, 
        // startAt: {gt: monday},//{gt: yesterday}, 
        // filter: {
        //   startAt: {gt: monday},//{gt: yesterday}, 
        //   stopAt: {lt: nextMonday},//{lt: tomorrow}, 
        //   // confirmed: {eq: true},
        //   deleted: {ne: true}
        // }
        }});

  const [fetchShiftsData, {data: shiftsData, loading: shiftsLoading, 
    error: shiftsError}] = useLazyQuery<ShiftsByComIdQuery, ShiftsByComIdQueryVariables>(shiftsByComId);

  const [fetchPunchesData, {data: punchesData, loading: punchesLoading, 
    error: punchesError, refetch: refetchPunches, fetchMore: punchesFetchMore}] = useLazyQuery<PunchsByShiftQuery, PunchsByShiftQueryVariables>(punchsByShift);
      
  const [fetchManagers, {data: dataManagers, loading: loadingManagers, error: errorManagers, 
          refetch: refetchManagersData, fetchMore: fetchMoreManagers}] = 
          useLazyQuery<UsersByComIdQuery, UsersByComIdQueryVariables >(usersByComId);

  const [doUpdateShift] = useMutation<UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables>(updateAgendaShift);
            // console.log(monday);

  // useEffect(() => {
  //   if (dataShifts && !loadingShifts) {
  //     fetchDataShifts({variables: {
  //       userId: id,
  //       startAt: { eq: new Date().toISOString() },
  //       // filter: { 
  //       //   stopAt: {lt: tomorrow},
  //       //   confirmed: {eq: true},
  //       //   suspended: {eq : false},
  //       //   deleted: {ne: true}}
  //       }});
  //     }
  //     // console.log("USERS ->", users);
  // }, [id]);
  
  const user = dataUser?.getAgendaUser;
  const shift = data?.getAgendaShift;

  useEffect(() => {
    document.title = t('title.shift');
  }, []);

  useEffect(() => {
    setNotificationCount && setNotificationCount((notificationCount ?? 0) - (shiftCount ?? 0) - (confirmShiftCount ?? 0));
    updateNotificationModelCount('shift', 0);
    updateNotificationModelCount('confirmShift', 0);
    setShiftCount && setShiftCount(0);
    setConfirmShiftCount && setConfirmShiftCount(0);
    setShiftLink && setShiftLink("");
    setConfirmShiftLink && setConfirmShiftLink("");
  }, [location]);

  useEffect(() => {
    if (location.state && (location.state as any).refetchData) {
      console.log('REFETCH SHIFT DATA');
      refetch();
      refetchPunches();
    }
  }, [location.state]);

  useEffect(() => {
    if (dataUser) {
        if (user?.comId) {
            if (shift?.startAt && shift?.stopAt) {
              const beforeDate = getDateMinusDays(shift?.startAt, 3);
              const afterDate = getDatePlusDays(shift?.stopAt, 3);
              fetchShiftsData({variables: {comId: user?.comId, //limit: 10, 
                  startAt: { between: [beforeDate, shift.stopAt] },
                  // limit: 6,
                  filter: 
                  {
                    location: {eq: shift?.location},
                    stopAt: {between: [shift.startAt, afterDate]}
                  }
              }});
            }
            if (shift?.shiftId) {
              fetchPunchesData({variables: {
                shiftId: shift?.shiftId,
                limit: 10,
                sortDirection: ModelSortDirection.DESC,
              }});
            }
            fetchManagers({variables: {
              comId: user?.comId, 
              sortDirection: ModelSortDirection.DESC, 
              // limit: 10, 
              filter: {
                  suspended: {ne: true},
                  type: {eq: "MANAGER" as AgendaUserType}
            }}});
        }
    }
  }, [data, dataUser]);

  useEffect(() => {
    if (!user) return;
    if (!user.language) return;
    setLocale(user?.language);
  }, [user])

  const shifts = shiftsData?.shiftsByComId?.items || [];
  const punches = punchesData?.punchsByShift?.items || [];
  const managers = dataManagers?.usersByComId?.items || [];

  useEffect(() => {
      if (!shift) return;
      if (!shift.comId) return;
      setShiftData({
          quality: shift.quality ?? "0",
          performance: shift.performance ?? "0",
          punctuality: shift.punctuality ?? "0",
          rate: shift.rate ?? "0",
      })
  }, [shift]);

  // SERVICES
  // const {truncate} = useHelperService();
  const {onUpdateShiftAccept, onUpdateShiftConfirm, onUpdateShiftUnConfirm, onDeleteShift, onUpdateRank, onUpdateHonor} = useShiftService(
      shift as AgendaShift, user?.type == "MANAGER" && true, locale, shift?.startAt?.split("T")[0], "ShiftDetail", managers);

  useEffect(() => {
    if (!punches) return;
    if (!punchesData?.punchsByShift?.nextToken) return;
    setNextToken(punchesData?.punchsByShift?.nextToken);
  }, [punches]);

  // PAGINATION
  useEffect(() => {
    if (!nextToken) return;
    const handleScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const scrolled = window.scrollY;
        if (scrollable - scrolled < 5) {
            loadMore();
        }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [nextToken, isFetchingMore]);

  // REFRESH BY SCROLLING
  useEffect(() => {
    if (!user) return;
    if (!user.type) return;
    if (!punches) return;
    if (!punches[0]) return;
    if (!punches[0].startAt) return;
    if (user.type === "MANAGER") {
      // window.scrollTo(0, 5);

      const handleScrollTop = () => {
        if (window.scrollY < 3 && !isRefreshingRef.current) {
          // console.log('Refreshing punches...');
          isRefreshingRef.current = true;
          refreshingPunches();
          // window.scrollTo(0, 5);

          setTimeout(() => {
              isRefreshingRef.current = false;
          }, 2000);
        }
      };

      window.addEventListener("scroll", handleScrollTop);

      return () => {
        window.removeEventListener("scroll", handleScrollTop);
      };
    }
  }, [punches]);

  if (!shift || !user || !managers) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  if (error) { //|| errorDelete) {
    return (
        <div className="users-container flex-grow-1 p-3">
            <h3>Error fetching the user</h3>
            <p>{error?.message || "User not found"}</p>
            <Link to="" onClick={() => window.location.reload()}>Reload</Link>
        </div>
    );
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }

  const startAt = new Date(shift.startAt);
  startAt.setHours(startAt.getHours() - TIMEZONE);
  const stopAt = new Date(shift.stopAt);
  stopAt.setHours(stopAt.getHours() - TIMEZONE);

  const acceptShift = async () => {
    setShowCustomModal(false);
    if (loadingButton) return;
    setLoadingButton(true);
    await onUpdateShiftAccept();
    setLoadingButton(false);
  };

  const confirmShift = async () => {
      setShowCustomModal(false)
      if (loadingButton) return;
      setLoadingButton(true);
      await onUpdateShiftConfirm();
      setLoadingButton(false);
  }

  const unconfirmShift = async () => {
      setShowCustomModal(false)
      if (loadingButton) return;
      setLoadingButton(true);
      await onUpdateShiftUnConfirm();
      setLoadingButton(false);
  }

  const applyOnShift = () => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.acceptedMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ () => acceptShift()}>
              {t('shift.accept')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  }

  const confirmOnShift = () => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.confirmedMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ () => confirmShift()}>
              {t('shift.confirm')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  }

  const unconfirmOnShift = () => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.unconfirmedMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ () => unconfirmShift()}>
              {t('shift.confirm')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  }

  const punchMap = (punch: any) => {
    const newCenter = {
      lat: parseFloat(punch.latitude), // ou punch.lat si c'est bien ce champ
      lng: parseFloat(punch.longitude)
    };
  
    setCenter(newCenter);

    const onLoad = (map: google.maps.Map) => {
      mapRef.current = map;
    };

    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title style={{ width: "100%", textAlign: "center" }}>{t('punch.location')}</Modal.Title>
        </Modal.Header>
      
        <Modal.Body style={{ display: 'flex', justifyContent: 'center' }}>
          {isLoaded ? (
            <GoogleMap
              // mapContainerStyle={containerStyle}
              mapContainerStyle={{ width: "300px", height: "300px" }} // , margin: '0 auto'
              center={newCenter}
              zoom={17}
              // onClick={onMapClick}
              onLoad={onLoad}
              options={{ streetViewControl: false, mapTypeControl: false }}
            >
              <Marker position={newCenter} />
            </GoogleMap>
          ) : (
            <div>Loading map...</div>
          )}
        </Modal.Body>
      </>);
    setShowCustomModal(true);
  }

  const loadMore = async () => {
    if (!nextToken || isFetchingMore) {
        return;
    };
    // console.log('allo', nextToken)
    setIsFetchingMore(true);
    try {
        await punchesFetchMore({
            variables: {
                shiftId: shift?.shiftId,
                limit: 10,
                nextToken: nextToken,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult?.punchsByShift) return prev;

                const newItems = fetchMoreResult.punchsByShift.items ?? [];
                const newNextToken = fetchMoreResult.punchsByShift.nextToken;
                setNextToken(newNextToken);

                return {
                    punchsByShift: {
                        // __typename: prev.punchsByShift?.__typename || '',
                        __typename: "ModelAgendaPunchConnection",
                        items: [...((prev.punchsByShift?.items) ?? []), ...newItems],
                        nextToken: newNextToken,
                    }
                };
            }
        });
    } catch (err) {
        console.error("Error loading more punches", err);
    }
    setIsFetchingMore(false);
  };

  const refreshingPunches = () => {
      // setNewPunches([]);
      refetchPunches();
  };

  // RANK FUNCTIONS
  const handleRatingChange = (field: any, newRating: any) => {
      setShiftData(prevData => ({
          ...prevData,
          [field]: String(newRating), // Convertir en chaîne pour correspondre au modèle "a.string()"
      }));
  };

  const rankShift = async () => {
    if (loadingButton) return;
    setLoadingButton(true);
    await onUpdateRank(shiftData);
    setLoadingButton(false);
  }

  const honorShift = async () => {
    if (loadingButton) return;
    setLoadingButton(true);
    // @ts-ignore
    if (shift?.honors && shift?.honors?.items.length < 1) {
      await onUpdateHonor(honorData);
    } else {
      alert('You already set an honor for this shift.');
    }
    setLoadingButton(false);
  }

  const goToRankShift = () => {
    setShowRankModal(true);
  }

  const goToHonorShift = () => {
    setShowHonorModal(true);
  }

  const handleSubmit = () => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.formSubmit')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{`${t('shift.quality')}: ${shiftData.quality}`}</p>
            <p>{`${t('shift.performance')}: ${shiftData.performance}`}</p>
            <p>{`${t('shift.punctuality')}: ${shiftData.punctuality}`}</p>
            <p>{`${t('shift.rate')}: ${shiftData.rate}`}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ async () => {
              await rankShift();
              setShowCustomModal(false);
              setShowRankModal(false);
              setShowHonorModal(false);
            }}>
              {t('shift.rankUpdate')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const handleHonorSubmit = () => {
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.formHonorSubmit')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{`
            ${honorData === "D" ? t('shift.roundMedal') : 
            honorData === "C" ? t('shift.starMedal') :
            honorData === "B" ? t('shift.trophy') :
            honorData === "A" ? t('shift.trophy2') : ""
            }`}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Button>
            <Button variant="primary" onClick={ async () => {
              await honorShift();
              setShowCustomModal(false);
              setShowRankModal(false);
              setShowHonorModal(false);
            }}>
              {t('shift.rankUpdate')}
            </Button>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const goToCreateSwapShift = (id: string) => {
    navigate(t('link.swap_create') + id);
  } 

  // shifts.filter((item) => item?.shiftId !== shift.shiftId).slice(0, 4).map((job, index) => {
  //   console.log(job);
  // });
  return (
    <>
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <Stack direction="vertical" gap={3} className="w-100 pt-3">
            <>
              <div
                className="p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
                key={`user_${shift.shiftId}`}
              >
                  <Row className="g-3 pt-3">
                    {/* Avatar */}
                    <Col xs={12} md={6} className="d-flex flex-column align-items-start flex-shrink-0 w-auto">
                      <div className="flex-grow-2">
                        <p>
                          <Link to={`${t('link.user')}/${shift.userId}`} className="text-decoration-none text-dark fw-bold link">
                            {shift.username}
                          </Link>
                        </p>
                        <p style={{fontSize: 10}}>{t('shift.startAt')}{format(startAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                        <p style={{fontSize: 10}}>{t('shift.stopAt')}{format(stopAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                      </div>
                      <div className="flex-grow-2 mb-2">
                          { shift.accepted ?
                            <p style={{fontSize: 10, color: 'green'}}>{t('shift.accepted')}</p>
                          :
                            (AuthUserId === shift.userId || user.type === "MANAGER") &&
                              <Button variant="success" title={loadingButton ? t('signup.loading') : t('shift.accept')} onClick={() => applyOnShift()} >{t('shift.accept')}</Button>
                          }
                        </div>
                        <div className="flex-grow-2">
                          { shift.confirmed ?
                            user.type === "MANAGER" ?
                              <Button variant="danger" title={loadingButton ? t('signup.loading') : t('shift.unconfirm')} onClick={() => unconfirmOnShift()} >{t('shift.unconfirm')}</Button>
                            :
                              <p style={{fontSize: 10, color: 'green'}}>{t('shift.confirmed')}</p>                           
                          :
                            (user.type === "MANAGER") ?
                              <>
                                <Button variant="success" title={loadingButton ? t('signup.loading') : t('shift.confirm')} onClick={() => confirmOnShift()} >{t('shift.confirm')}</Button>
                            
                              </>
                              
                            :
                              <p>{t('shift.awaitingConfirmation')}</p>
                          }
                        </div>
                    </Col>

                    {/* Infos utilisateur */}
                    <Col className="ps-3">
                      <div className="flex-grow-1 ">
                        <p>{t('shift.title')}{shift.role}</p>
                        <p>{t('shift.location')}{shift.location}</p>
                        <p>{t('shift.information')}{shift.info}</p>
                      </div>
                    </Col>
                    { user?.type === "MANAGER" ?
                      <Col className="ps-3">
                        <div className="flex-grow-1 pb-5 text-end">
                          <MdSwapHorizontalCircle onClick={() => goToCreateSwapShift(shift.shiftId)} className="hover-icon" size={80} />
                        </div>
                        <div className="flex-grow-1 pb-5 text-end">
                          <FaRankingStar name="ranking-star" onClick={() => goToRankShift()} className="hover-icon" size={80} />
                        </div>
                        <div className="flex-grow-1 pb-5 text-end">
                          <IoRibbon name="honor-user" onClick={() => goToHonorShift()} className="hover-icon" size={80} />
                        </div>
                      </Col>
                    :
                      shift.userId === AuthUserId &&
                        <Col className="ps-3">
                          <div className="flex-grow-1 pb-5 text-end">
                            <MdSwapHorizontalCircle onClick={() => goToCreateSwapShift(shift.shiftId)} className="hover-icon" size={80} />
                          </div>
                        </Col>
                    }
                  </Row>
                      { shifts &&
                        <>
                          <Row className="d-flex justify-content-center align-items-center text-center">
                            <Col className="d-flex justify-content-center">
                              {shifts
                                .filter((item) => item?.shiftId !== shift.shiftId)
                                .filter((item) => (item as any)?.user.userId !== AuthUserId)
                                .slice(0, 40)
                                .map((job, index) => (
                                    <Link to={`${t('link.user')}/${(job as any).user.userId}`} className="text-decoration-none text-dark fw-bold link">
                                      <UserImage user={(job as any).user} customClass="coworker_sm shadow-sm hover:shadow-md" key={"worker_" + job?.userId} />
                                    </Link>
                                ))}
                            </Col>
                          </Row>

                          <Row className="d-flex justify-content-center align-items-center text-center mt-2">
                            <Col>
                              <Link to={`${t('link.shift')}/${id}/${t('link.coworkers')}`} className="text-decoration-none text-dark fw-bold link">
                                {shifts.length > 6 ? <p>{t('shift.viewMore')}</p> : shifts.length > 1 && <p>{t('shift.showDetails')}</p>}
                              </Link>
                            </Col>
                          </Row>
                        </>
                      }
                </div>
                { user.type === "MANAGER" &&
                
                    // @ts-ignore
                    punches.map((punch) => {
                    const punch_startAt = new Date(punch.startAt);
                    punch_startAt.setHours(punch_startAt.getHours());
                    
                    // const newCenter = {
                    //   lat: parseFloat(point.latitude), // ou punch.lat si c'est bien ce champ
                    //   lng: parseFloat(point.longitude)
                    // };
                  
                    // setCenter(newCenter);
                
                    // const onLoad = (map: google.maps.Map) => {
                    //   mapRef.current = map;
                    // };
                    return (<div
                      className="p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
                      key={`punch_${punch.punchId}`}
                    >
                      {/* <h4>{punch.heading}</h4> */}
                      <h4>{t('punch.at')}</h4>
                      <p>{format(punch_startAt, "EEEE d MMMM yyyy, HH:mm", {locale: getLanguage()})}</p>
                      <p>
                        <Link to="" onClick={() => punchMap(punch)} >
                          {t('punch.location')}
                        </Link>
                      </p>
                      {/* <p> */}
                        {/* <GoogleMap
                          // mapContainerStyle={containerStyle}
                          mapContainerStyle={{ width: "200px", height: "200px" }}
                          center={newCenter}
                          zoom={17}
                          // onClick={onMapClick}
                          onLoad={onLoad}
                          options={{ streetViewControl: false, mapTypeControl: false }}
                        >
                          <Marker position={newCenter} />
                        </GoogleMap> */}
                      {/* </p> */}
                    </div>)}
                  )
                }
            </>
          </Stack>
        </div>
      </div>
      <Modal
        show={showRankModal} // 'visible' devient 'show' pour React-Bootstrap
        onHide={() => setShowRankModal(false)} // Gère la fermeture via le bouton X, l'échap ou le clic en dehors
        centered // Centre le modal à l'écran
        backdrop="static" // Empêche la fermeture du modal en cliquant à l'extérieur
        keyboard={false} // Empêche la fermeture du modal avec la touche Échap
        style={{
          // Ces styles sont pour l'overlay du modal (l'arrière-plan semi-transparent)
          // et sont gérés par React-Bootstrap. Vous n'aurez peut-être pas besoin de les modifier.
        }}
      >
        <Modal.Header closeButton> {/* Ajoute un bouton de fermeture automatique */}
          <Modal.Title style={{ paddingTop: 10, textAlign: 'center', width: '100%' }}>
            {t('shift.rankShiftTitle')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{
          backgroundColor: '#EEE', // Fond du corps du modal
          borderRadius: '0 0 10px 10px', // Bords arrondis seulement en bas si le header est arrondi
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          // La hauteur n'est généralement pas fixe pour les modales, mais si nécessaire :
          // height: '500px',
        }}>
          <div className="containerRank" style={{ width: '100%' }}>
            {/* Section Qualité */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
            }}>
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.quality')}
              </p>
              <StarRating
                rating={parseInt(shiftData?.quality)}
                onRatingChange={(newRating: any) => handleRatingChange('quality', newRating)}
              />
              <p className="currentRatingText" style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#555' }}>
                {shift.quality} {t('shift.star')}
              </p>
            </div>

            {/* Section Performance */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
            }}>
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.performance')}
              </p>
              <StarRating
                rating={parseInt(shiftData?.performance)}
                onRatingChange={(newRating: any) => handleRatingChange('performance', newRating)}
              />
              <p className="currentRatingText" style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#555' }}>
                {shift.performance} {t('shift.star')}
              </p>
            </div>

            {/* Section Ponctualité */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
            }}>
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.punctuality')}
              </p>
              <StarRating
                rating={parseInt(shiftData?.punctuality)}
                onRatingChange={(newRating: any) => handleRatingChange('punctuality', newRating)}
              />
              <p className="currentRatingText" style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#555' }}>
                {shift.punctuality} {t('shift.star')}
              </p>
            </div>

            {/* Section Taux */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
            }}>
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.rate')}
              </p>
              <StarRating
                rating={parseInt(shiftData?.rate)}
                onRatingChange={(newRating: any) => handleRatingChange('rate', newRating)}
              />
              <p className="currentRatingText" style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#555' }}>
                {shift.rate} {t('shift.star')}
              </p>
            </div>

            <Button
              variant="primary" // Style de bouton de React-Bootstrap
              onClick={() => handleSubmit()}
              disabled={loadingButton}
              className="w-100 mt-3" // Classes Bootstrap pour largeur 100% et marge top
            >
              {loadingButton ? <Spinner animation="border" size="sm" /> : t('shift.saveRank')}
            </Button>
          </div>

          <div className="rankFooter" style={{ marginTop: '20px', width: '100%', textAlign: 'center' }}>
            <Button
              variant="secondary" // Style de bouton secondaire
              onClick={() => setShowRankModal(false)}
            >
              {t('punch.close')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showHonorModal} // 'visible' devient 'show' pour React-Bootstrap
        onHide={() => setShowHonorModal(false)} // Gère la fermeture via le bouton X, l'échap ou le clic en dehors
        centered // Centre le modal à l'écran
        backdrop="static" // Empêche la fermeture du modal en cliquant à l'extérieur
        keyboard={false} // Empêche la fermeture du modal avec la touche Échap
        style={{
          // Ces styles sont pour l'overlay du modal (l'arrière-plan semi-transparent)
          // et sont gérés par React-Bootstrap. Vous n'aurez peut-être pas besoin de les modifier.
        }}
      >
        <Modal.Header closeButton> {/* Ajoute un bouton de fermeture automatique */}
          <Modal.Title style={{ paddingTop: 10, textAlign: 'center', width: '100%' }}>
            {t('shift.honorShiftTitle')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{
          backgroundColor: '#EEE', // Fond du corps du modal
          borderRadius: '0 0 10px 10px', // Bords arrondis seulement en bas si le header est arrondi
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          // La hauteur n'est généralement pas fixe pour les modales, mais si nécessaire :
          // height: '500px',
        }}>
          <div className="containerRank" style={{ width: '100%' }}>
            {/* Section Qualité */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
              // @ts-ignore
              backgroundColor: honorData === "D" ? '#bdbdd9' : shift?.honors?.items?.[0]?.type == "D" ? '#bdbdd9' : 'white',
              cursor: 'pointer'
            }}
            onClick={() => setHonorData("D")}
            >
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.roundMedal')}
              </p>
              <IoMedal
                name={"medal"}
                style={{color: '#FFD700', marginBottom: 10}}
                size={60}
              />
            </div>

            {/* Section Performance */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
              // @ts-ignore
              backgroundColor: honorData === "C" ? '#bdbdd9' : shift?.honors?.items?.[0]?.type == "C" ? '#bdbdd9' : 'white',
              cursor: 'pointer'
            }}
            onClick={() => setHonorData("C")}
            >
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.starMedal')}
              </p>
              <FaMedal
                name={"medal"}
                style={{color: '#FFD700', marginBottom: 10}}
                size={60}
              />
            </div>

            {/* Section Ponctualité */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
              // @ts-ignore
              backgroundColor: honorData === "B" ? '#bdbdd9' : shift?.honors?.items?.[0]?.type == "B" ? '#bdbdd9' : 'white',
              cursor: 'pointer'
            }}
            onClick={() => setHonorData("B")}
            >
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.trophy')}
              </p>
              <BsFillTrophyFill
                name={"trophy"}
                style={{color: '#FFD700', marginBottom: 10}}
                size={60}
              />
            </div>

            {/* Section Taux */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '15px',
              // @ts-ignore
              backgroundColor: honorData === "A" ? '#bdbdd9' : shift?.honors?.items?.[0]?.type == "A" ? '#bdbdd9' : 'white',
              cursor: 'pointer'
            }}
            onClick={() => setHonorData("A")}
            >
              <p className="labelRank" style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold' }}>
                {t('shift.trophy2')}
              </p>
              <GiTrophy
                name={"medal"}
                style={{color: '#FFD700', marginBottom: 10}}
                size={60}
              />
            </div>

            <Button
              variant="primary" // Style de bouton de React-Bootstrap
              onClick={() => handleHonorSubmit()}
              disabled={loadingButton}
              className="w-100 mt-3" // Classes Bootstrap pour largeur 100% et marge top
            >
              {loadingButton ? <Spinner animation="border" size="sm" /> : t('shift.saveRank')}
            </Button>
          </div>

          <div className="rankFooter" style={{ marginTop: '20px', width: '100%', textAlign: 'center' }}>
            <Button
              variant="secondary" // Style de bouton secondaire
              onClick={() => setShowHonorModal(false)}
            >
              {t('punch.close')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ShiftView;


